import { createContext } from 'react';

export const TabsContext = createContext({
    activeTab: '',
    setActiveTab: () => {},
    disabledTransition: false,
    variant: 'default',
});
